/** Eingangskanal eines Vertragsanliegens; Werte wie `ContractRequestChannel` im Backend. */
export const CONTRACT_REQUEST_CHANNEL_DESK = 1;
export const CONTRACT_REQUEST_CHANNEL_PHONE = 2;
export const CONTRACT_REQUEST_CHANNEL_EMAIL = 3;
export const CONTRACT_REQUEST_CHANNEL_APP = 4;
export const CONTRACT_REQUEST_CHANNEL_LETTER = 5;

export type ContractRequestChannel = 1 | 2 | 3 | 4 | 5;

export function contractRequestChannelLabelKey(channel: number | null | undefined): string | null {
  switch (channel) {
    case CONTRACT_REQUEST_CHANNEL_DESK: return "Request channel desk";
    case CONTRACT_REQUEST_CHANNEL_PHONE: return "Request channel phone";
    case CONTRACT_REQUEST_CHANNEL_EMAIL: return "Request channel email";
    case CONTRACT_REQUEST_CHANNEL_APP: return "Request channel app";
    case CONTRACT_REQUEST_CHANNEL_LETTER: return "Request channel letter";
    default: return null;
  }
}
